import { Component } from '@angular/core';

@Component({
    selector: 'app-swiper',
    templateUrl: './swiper.component.html',
    standalone: false
})
export class SwiperComponent {

}
